import { render, staticRenderFns } from "./coupons.vue?vue&type=template&id=466bccb0&scoped=true&"
import script from "./coupons.vue?vue&type=script&lang=js&"
export * from "./coupons.vue?vue&type=script&lang=js&"
import style0 from "./coupons.vue?vue&type=style&index=0&id=466bccb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466bccb0",
  null
  
)

export default component.exports